import { logAppError } from 'Helpers/logger'
import { type Getter, type Setter } from 'jotai'
import { STORE_KEY_ID_LIST, storeGet } from 'mailup-react-helpers'
import {
  defaultPageState,
  errorUpdater,
  loaderUpdater,
  pageState,
  statusUpdater,
} from 'State/page'
import { beListApiGetEntitiesUsingFilter } from '../../../api/beListApi'
import { getFilter } from '../services/services'
import {
  defaultGoToRecipientModalState,
  defaultSubscriberState,
  filterFormAtom,
  getDefaultFilter,
  goToRecipientModalAtom,
  originalFilterAtom,
  subscriberCountAtom,
} from '../state/state'
import { dirtyFieldsAtom } from '../state/validation'
import { getGeoCountriesCallback, resetSpecState } from './specsCallbacks'

export const initPageCallback = async (
  _: Getter,
  set: Setter,
  id?: number,
): Promise<void> => {
  console.log('### initPageCallback')
  set(pageState, loaderUpdater(true))
  resetAdditionalState(set)
  try {
    const isNew = id === undefined || id === 0
    const filter = isNew ? getDefaultFilter() : await getFilter(id)
    let isUsedInOtherLists = false

    if (!isNew) {
      const entitiesUsingFilter = await beListApiGetEntitiesUsingFilter(id)
      if (
        entitiesUsingFilter.length > 0 &&
        entitiesUsingFilter.some(
          (i) => i.IdList !== storeGet(STORE_KEY_ID_LIST),
        )
      ) {
        isUsedInOtherLists = true
      }
    }

    void getGeoCountriesCallback(_, set)

    set(filterFormAtom, { ...filter, IsUsedInOtherLists: isUsedInOtherLists })
    set(originalFilterAtom, {
      ...filter,
      IsUsedInOtherLists: isUsedInOtherLists,
    })

    set(pageState, statusUpdater('ready'))
  } catch (e) {
    console.error('### error', e)

    logAppError({
      Component: 'CombinedFilterFormPage',
      Method: 'initPageCallback',
      appError: e instanceof Error ? e : undefined,
    })

    set(pageState, errorUpdater)
  }

  set(pageState, loaderUpdater(false))
}

export const resetPageCallback = (_: Getter, set: Setter): void => {
  set(pageState, defaultPageState)
  set(filterFormAtom, getDefaultFilter())
  set(originalFilterAtom, getDefaultFilter())
  resetAdditionalState(set)
  resetSpecState(set)
}

const resetAdditionalState = (set: Setter): void => {
  set(dirtyFieldsAtom, [])
  set(subscriberCountAtom, defaultSubscriberState)
  set(goToRecipientModalAtom, defaultGoToRecipientModalState)
}
